import rest from "@/rest-client";
import vuexStore from "@/store/customSaveStore";

export const datasubjectDatasubjectRight = vuexStore({
  namespaced: true,
  path: "/datasubject-datasubject-right",
  state: {
    editedDatasubject: null,
  },
  getters: {
    editedDatasubject: (state) => state.editedDatasubject,
  },
  mutations: {
    editedDatasubject: (state, value) => (state.editedDatasubject = value),
  },
  actions: {
    addFromLibrary({ commit }, payload) {
      commit("isUpdating", true);
      try {
        return rest.post("/datasubject-datasubject-right", payload);
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});
